import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { CardViewWebElement } from './CardViewWebElement';
export { CardViewWebElement };

/**
 * Retrieve an instance of [CardViewWebElement](../classes/CardViewWebElement.html).
 * @example
 * ```javascript
 * import { findCardView } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findCardView(driver, By.id('my-oj-c-card-view'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findCardView(driver: DriverLike, by: By): Promise<CardViewWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type CardViewWebElement
  if (!(webEl instanceof CardViewWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'CardViewWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findCardView(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${CardViewWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-card-view', CardViewWebElement);
